import {AxiosChatInstance, AxiosPublicationsInstance} from "../api/AxiosInstance";

// Ver Notificaciones Generales
export const getNotifications = async (userId, filters = {}) => {
  try {
    const params = new URLSearchParams({
      IdUsuario: userId,
    });

    if (typeof filters.page === "number") {
      params.append("page", String(filters.page));
    }

    if (typeof filters.pageSize === "number") {
      params.append("pageSize", String(filters.pageSize));
    }

    if (typeof filters.visto === "boolean") {
      params.append("visto", String(filters.visto));
    }

    const response = await AxiosChatInstance.get(
      `/api/vnotify/gral?${params.toString()}`,
    )
    const responseBody = response.data;

    if (Array.isArray(responseBody)) {
      return responseBody;
    }

    if (Array.isArray(responseBody?.data)) {
      return responseBody.data;
    }

    return []
  } catch (error) {
    throw error?.response || "Failed getting notifications"
  }
}

export const confirmFollow = async (users) => {
  try {
    const response = await AxiosPublicationsInstance.post("/api/user/estatusrel", users)
    return response.data
  }catch (error) {
    throw error?.response || "Failed confirm follow"
  }
}

export const rejectFollow = async (users) => {
  try {
    const response = await AxiosPublicationsInstance.post("/api/user/delfollow", users)
    return response.data
  }catch (error) {
    throw error?.response || "Failed confirm follow"
  }
}

//Total de notificaciones generales
export const getMessagesNotification = async (userId) => {
  try {
    const response = await AxiosChatInstance.get(`/api/tnotify/gral?IdUsuario=${userId}`)
    return response.data
  } catch (error) {
    throw error?.response || "Failed getting messages notifications"
  }
}

//Redirección de notificaciones generales
export const getRedirectNotification = async (notification) => {
  try {
    const response = await AxiosChatInstance.get(`/api/redirec/gral?IdUsuario=${notification?.userId}&IdPublicacion=${notification?.publicationId}`)
    return response.data?.data ?? response.data
  } catch (error) {
    throw error?.response || "Failed getting messages notifications"
  }
}

// Ver Mensajes
export const getMessages = async (userId, filters = {}) => {
  try {
    const params = new URLSearchParams({
      IdUsuario: userId,
    });

    if (typeof filters.mostrarArchivados === "boolean") {
      params.append("MostrarArchivados", String(filters.mostrarArchivados));
    }

    if (typeof filters.estatusMensaje === "number") {
      params.append("EstatusMensaje", String(filters.estatusMensaje));
    }

    const requestUrl = `/api/vnotify/msj?${params.toString()}`;
 
    const response = await AxiosChatInstance.get(
      requestUrl,
    )

    const responseBody = response.data;

    if (Array.isArray(responseBody)) {
      return responseBody;
    }

    if (Array.isArray(responseBody?.data)) {
      return responseBody.data;
    }

    return []
  } catch (error) {
    console.error("[Messages][Repository] Error", {
      userId,
      filters,
      error,
    });
    throw error?.response || "Failed getting messages"
  }
}

//Marcar mensaje como visto

export const seenMessageRepository = async (payload) => {
  try {
    const params = new URLSearchParams({
      IdUsuario: payload?.IdUsuario ?? "",
      IdAmigo: payload?.IdAmigo ?? "",
    });

    const requestUrl = `/api/msj/leido?${params.toString()}`;
  

    const response = await AxiosChatInstance.get(requestUrl)

    return response.data
  } catch (error) {
    console.error("[Messages][Seen] Error", {
      payload,
      error,
    });
    throw error?.response || "Failed seeing message"
  }
}

//marcar notificacion vista

export const seenNotificationRepository = async (payload) => {
  try {
    const params = new URLSearchParams({
      IdNotificacion: payload.IdNotificacion ?? "",
      IdUsuario: payload?.IdUsuario ?? "",

    });

    const response = await AxiosChatInstance.get(
      `/api/actnotify/gral?${params.toString()}`,
    )

      
    return response.data;

    
  } catch (error) {
    console.error("[Notifications][Seen] Failed mark as read notifications", {
      payload,
      error,
    });
    throw error?.response || "Failed mark notification as seen"
  }
}

//Marcar notificacion 
